export default "__VITE_ASSET__2982d79e__"